module.exports = __webpack_public_path__ + "static/DashboardSchedule-dab7dae4a4e7e0bb674d4e1b5bddd187.mp4";